import { usePrivilegesQuery } from '@generated'
import { FC } from 'react'
import { Item } from '@lib/kontent'
import { PrivilegeItem } from '@lib/kontent/models/PrivilegeItem'
import { MembershipSliderTrack } from '../SliderTrack'
import { PrivilegeSliderItem } from './Item'

type MembershipPrivilegeSliderProps = {
  privileges: Item<PrivilegeItem>[]
  title: string
  modularContent: { [key: string]: any }
}

export const MembershipPrivilegeSlider: FC<MembershipPrivilegeSliderProps> = ({
  title,
  privileges,
  modularContent,
}) => {
  const [{ data }] = usePrivilegesQuery()

  if (privileges.length === 0) {
    return null
  }

  return (
    <MembershipSliderTrack title={title} itemLength={privileges.length}>
      {privileges.map((item, index) => {
        const dafItem = data?.privileges?.find(
          (i) => i?.privilege_nr === item.elements.privilege_number.value,
        )
        if (!dafItem) return null
        return (
          <>
            {index !== 0 && <div className="h-full min-w-[16px] md:min-w-[24px]" />}
            <PrivilegeSliderItem
              key={index}
              dafItem={dafItem}
              modularContent={modularContent}
              {...item}
            />
          </>
        )
      })}
    </MembershipSliderTrack>
  )
}
